export const WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER = ":slug";

// All workspace sections live under `/{slug}/{section}` now. The slug is the
// namespace's URL-safe identifier (resolved server-side to a namespaceId for
// API calls). Keep the placeholder shape so navigation config can render the
// templates as labels (":slug") when no active namespace is selected yet.
export const WORKSPACE_ROUTE_TEMPLATES: Record<string, string> = {
  next: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/next`,
  ideas: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/ideas`,
  "task-list": `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/tasks`,
  goals: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/goals`,
  "cron-jobs": `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/cron-jobs`,
  documentation: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/documents`,
  governance: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/governance`,
  atlas: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/atlas`,
  flow: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/flow`,
  guide: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/guide`,
  integrations: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/integrations`,
  plc: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/plc`,
  conventions: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/conventions`,
  advisory: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/advisory`,
  files: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/files`,
  repository: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/repository`,
  changes: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/changes`,
  audit: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/audit`,
  settings: `/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}/settings`,
};

/**
 * Resolve a logical workspace tab id (e.g. "tasks", "audit") to the concrete
 * client route, substituting the namespace slug when present.
 *
 * When `slug` is omitted (the active namespace hasn't been resolved yet) we
 * return the bare `/section` form — the top-level redirect routes will then
 * server-resolve the user's default namespace (last-viewed → first namespace)
 * and forward to `/{slug}/section`. Anything else risks shipping a fake
 * "default" placeholder slug into the URL.
 */
export function resolveWorkspaceRoute(tabId: string, slug?: string | null) {
  const template = WORKSPACE_ROUTE_TEMPLATES[tabId];
  if (!template) {
    return undefined;
  }

  if (!slug) {
    // Drop the leading "/<placeholder>" so the URL becomes "/<section>".
    return template.replace(`/${WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER}`, "");
  }

  return template.replace(WORKSPACE_ROUTE_NAMESPACE_PLACEHOLDER, encodeURIComponent(slug));
}
